<template>
    <div>
        <CustomTable
            :items="tables.acceptanceFilters.items"
            :fields="traslateLabels(tables.acceptanceFilters.fields)"
            v-bind="tables.acceptanceFilters"
        >
            <template #fieldName="{ index }">
                <CSelect
                    :value.sync="
                        tables.acceptanceFilters.items[index].fieldName
                    "
                    :options="fieldsModel"
                    :placeholder="$t('select_a_field')"
                    :invalidFeedback="$t('fied_is_required')"
                    size="sm"
                    class="mb-0"
                />
                <!-- <SelectFields
                        :placeholder="$t('select_a_field')"
                        :value.sync="
                            tables.acceptanceFilters.items[index].fieldName
                        "
                        size="sm"
                        :optionsValue="'name'"
                    /> -->
            </template>
            <template #condition="{ index }">
                <CSelect
                    :value.sync="
                        tables.acceptanceFilters.items[index].condition
                    "
                    :options="
                        traslateLabels($options.options.FilterTypeOptions)
                    "
                    :placeholder="$t('select_an_option')"
                    :invalidFeedback="$t('field_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template #value="{ index }">
                <SelectAsync
                    v-if="
                        tables.acceptanceFilters.items[index].fieldName ==
                        'provider_id'
                    "
                    :value.sync="tables.acceptanceFilters.items[index].value"
                    :placeholder="$t('select_an_option')"
                    size="sm"
                    :optionsValue="'id'"
                    :optionsLabel="'name'"
                    :endpoint="'provider'"
                    typeSelect="CSelect"
                />
                <CInput
                    v-else
                    :value.sync="tables.acceptanceFilters.items[index].value"
                    :placeholder="$t('enter_the_value')"
                    :invalidFeedback="$t('value_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template #options="{ index }">
                <div class="table-options">
                    <CButton
                        color="danger"
                        variant="outline"
                        square
                        size="sm"
                        @click="deleteItemToTable('acceptanceFilters', index)"
                    >
                        <CIcon
                            class="icon"
                            :content="$options.icons.cilTrash"
                        />
                    </CButton>
                </div>
            </template>
            <template #no-items-view>
                <div class="block-no-items section">
                    <h2 class="section__title text-no-items">
                        {{ $t("add_acceptance_filter") }}
                    </h2>
                    <CButton
                        color="success"
                        class="button m-2 shadow"
                        @click="addFilter"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.cilPlus" />
                        </span>
                        <span class="button__text">
                            {{ $t("add") }}
                        </span>
                    </CButton>
                </div>
            </template>
            <template #under-table>
                <CButton
                    color="success"
                    class="button m-2 shadow"
                    @click="addFilter"
                    v-if="tables.acceptanceFilters.items.length > 0"
                >
                    <span class="button__icon">
                        <CIcon :content="$options.icons.cilPlus" />
                    </span>
                    <span class="button__text">
                        {{ $t("add") }}
                    </span>
                </CButton>
            </template>
        </CustomTable>
    </div>
</template>

<script>
/**Components */
import SelectAsync from "£lement/SelectAsync";
import SelectFields from "£lement/SelectFields";
import CustomTable from "~/components/CustomTable";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";

export default {
    name: "AcceptanceFiltersManager",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
    },
    components: {
        SelectAsync,
        SelectFields,
        CustomTable,
    },
    data() {
        return {
            tables: {
                acceptanceFilters: {
                    items: [],
                    fields: [
                        {
                            key: "fieldName",
                            label: "field_name",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "condition",
                            label: "condition",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "value",
                            label: "value",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "options",
                            label: "options",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                        },
                    ],
                    loading: false,
                },
            },
            modals: {},
            modelFields: [],
        };
    },
    props: {
        fieldsModel: Array,
        conditions: Array,
        value: Array,
    },
    watch: {
        "tables.acceptanceFilters.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
        value(newValue) {
            if (Array.isArray(newValue)) {
                this.tables.acceptanceFilters.items = newValue;
            }
        },
    },
    methods: {
        addFilter() {
            let newItem = this.addItemToTable("acceptanceFilters");

            // Set by defult item.condition to equal why is the only options available
        },
    },
    mounted() {
        if (Array.isArray(this.value)) {
            this.tables.acceptanceFilters.items = this.value;
        }
    },
};
</script>

<style>
</style>